import React from 'react';
import { Link } from 'react-router-dom';

//** Lib's */
import { AppIcons } from '../../../data/appIcons';
import Image from '../../../components/image/Image';
import DataLoader from '../../../components/ui/dataLoader/DataLoader';

//** Service */
import { encryptUrlData } from '../../../services/CryptoService';

const HeaderSearch = (props) => {

  const handleEditClick = (id) => {
    window.open(`/CandidateDetail/${encryptUrlData(id)}`, "_blank");
  };

  return (
    <div className="main-header-dropdown-list header-search-list">
      <ul className="card-section p-0 header-search">
        {props.isLoading ? <DataLoader /> :
          <>
            {props.searchValue ?
              <>
                {props.candidateData?.length > 0 && props.candidateData !== undefined && props.candidateData != null ?
                  <>
                    {props.candidateData.map((data, index) => {
                      return (
                        <li key={index}>
                          <Link onClick={() => { handleEditClick(data.candidateId) }} className="mr-2">
                            <div>
                              {/* {data.gender === 'male' ? */}
                              <Image imagePath={data.gender === 'male' ? AppIcons.Maleheader : data.gender === 'female' ? AppIcons.Femaleheader : AppIcons.Maleheader}
                                imgCustomClassName="male-header" altText="User Image" />
                              {/* } */}
                            </div>
                            <div className="can-details">
                              <span> {data.fullName} </span>
                              <div className="d-flex">
                                <p>{data.contactPhone}</p>
                              </div>
                              <p> {data.contactEmail} </p>
                            </div>
                          </Link>
                        </li>
                      )
                    })}
                  </>
                  :
                  <div className="record-not-found">
                    <Image imagePath={AppIcons.noRecordImg} altText="Record Not Found" />
                    <h5>No Record Found</h5>
                  </div>
                }
              </>
              : ''
            }
          </>
        }
      </ul>
    </div >
  )
}

export default HeaderSearch